module.exports = new __parcel__URL__("Wmbf.7914dfe6.avif").toString();